module.exports = __webpack_public_path__ + "images/if6_schnellrechner_scenario_1.svg?99f3e6c7ec43967443c5edc00ca97c79";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/if6_schnellrechner_scenario_1.svg
// module id = 7beG
// module chunks = 0